import { __t } from '../../../base/utils/t';
import { DatePeriod, HireStatus } from './enums';

export const mapHireStatusToText = (status: HireStatus): string => {
    switch (status) {
        case HireStatus.All:
            return __t('Всі статуси');
        case HireStatus.Invited:
            return __t('Запрошений');
        case HireStatus.InProgress:
            return __t('В процесі');
        case HireStatus.NotInvited:
            return __t('Незапрошений');
        case HireStatus.Hired:
            return __t('Працевлаштований');
        default:
            return '';
    }
};

export const mapDatePeriodToText = (datePeriod: DatePeriod): string => {
    switch (datePeriod) {
        case DatePeriod.AllTime:
            return __t('За весь час');
        case DatePeriod.Today:
            return __t('За сьогодні');
        case DatePeriod.Yesterday:
            return __t('За вчора');
        case DatePeriod.Last7Days:
            return __t('За останні 7 днів');
        case DatePeriod.Last30Days:
            return __t('За останні 30 днів');
        case DatePeriod.CustomPeriod:
            return __t('За період');
        default:
            return '';
    }
};
